import { render, staticRenderFns } from "./UserLimitUpdateConfigurationForm.vue?vue&type=template&id=48c98a84&"
import script from "./UserLimitUpdateConfigurationForm.vue?vue&type=script&lang=js&"
export * from "./UserLimitUpdateConfigurationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports